<!--
 * @Description: 结构：左边菜单(NavigatorSubMenu.vue)，上边收藏栏(NaVerticalslot.vue)。layoutDirection: true
-->
<template>
  <div class="NaVertical cusTopHistoryFavorite">
    <div class="NaVertical-icons">
      <!-- 收拉左侧菜单 -->
      <slot name="icon-tag"></slot>
    </div>
    <div class="NaVertical-box">
      <!-- 自定义 问候-->
      <!-- <span class="timeTips"><template v-if='userName'>{{userName}}, </template>{{ timeTips }}, {{ welcome }}</span> -->

      <!-- <SelectTheme></SelectTheme> -->
      <!-- 模糊查询 -->
      <slot name="nav-input"></slot>

      <!-- 控制台 -->
      <slot name="icon-home"></slot>

      <!-- 常用菜单 -->
      <!-- <div class="tag right" @click="showMenu(0)" title="最近使用">
        <Icon type="md-time" />
        <span class="tag-title">最近使用<Icon type="ios-arrow-down" /></span>
        <div class="nav-menu" v-if="showHistoryMenu">
          <ul class="menu-ul">
            <li class="menu-li" v-for="menu in history" :key="menu.id" @click="routeTo(menu)">{{ menu.label }}</li>
          </ul>
        </div>
      </div> -->

      <!-- 收藏 -->
      <!-- <slot name="icon-Collect"></slot> -->
      <!-- <div class="tag right" @click="showMenu(1)" title="收藏夹">
        <Icon type="ios-star-outline" />
        <span class="tag-title">收藏夹<Icon type="ios-arrow-down" /></span>
        <div class="nav-menu" v-if="showFavoriteMenu">
          <ul class="menu-ul">
            <template v-if="favorite.length">
              <li class="menu-li" v-for="menu in favorite" :key="menu.id" @click="routeTo(menu)">{{ menu.label }}</li>
            </template>
            <template v-else>
              <li class="menu-li">暂无收藏记录</li>
            </template>
          </ul>
        </div>
      </div> -->
      <div class="tag right" @click="showMenu" :title="t('皮肤')">
        <OmsTheme :where="'nav'"></OmsTheme>
      </div>
      <!-- <div class="tag right" @click="screenfullFn">
        <i class="iconfont iconios-expand" v-if="!isFullscreen" />
        <i class="iconfont iconios-contract" v-if="isFullscreen" />
        <span class="tag-title">全屏<Icon type="ios-arrow-down" /></span>
      </div> -->
      <!-- 这个最近使用 -->
      <slot name="icon-Lately"></slot>
      <!-- 这个 设置【jlow、工作台】 -->
      <slot name="icon-Setting"></slot>
      <!-- 消息提示 -->
      <!-- <slot name="icon-task"></slot> -->
      <div class="tag right message-tag" @click="handlerOpenTasks" :title="t('消息')">
        <Badge :count="msgCount">
          <Icon type="md-notifications-outline" />
        </Badge>
        <span class="tag-title">{{t('消息')}}<Icon type="ios-arrow-down" /></span>
      </div>
      <div class="music" style="display:none;">
        <!-- <audio controls autoplay>
          <source src='/static/mp3/mm1.mp3' />
        </audio> -->
        <video id="ivvvv"></video>
        <iframe id="iffff" allow="autoplay" style="display:none" src=""></iframe>
      </div>
      <!-- 个人设置 -->
      <slot name="icon-person"></slot>
      <div class="tag right" @click="toggleSetting">
        <img v-if="gender == 'W'" :src="require('assetsImg/icon_user_female.png')" class="person famale" />
        <img v-else :src="require('assetsImg/icon_user_default.png')" class="person" />
        <span class="tag-title">{{ userName }}</span>
      </div>
    </div>
    <Modal
      v-model="forcePasswordChange"
      :mask="true"
      :mask-closable="false"
      :title="t('修改密码')"
      width="480"
      footer-hide
    >
      <ChangePassword @close="closePwdDialog" />
    </Modal>
  </div>
</template>

<script>
import service from '@/service/index';
import screenfull from 'screenfull';
import OmsTheme from './OmsTheme.vue'
import ChangePassword from '@/component/commonPages/ChangePassword.vue'
import { mapState, mapMutations, mapActions } from "vuex";
import utils from '@/assets/js/__utils__/route.js';

export default {
  name: "NaVerticalslot",
  components: {
    OmsTheme,
    ChangePassword
  },
  data () {
    return {
      timeTips: '',
      welcome: '欢迎来到 R3-OMS ！',
      // userName: localStorage.getItem('name'),
      isFullscreen: false,
      userName: '',
      gender: '',
      showFavoriteMenu: false,
      showHistoryMenu: false
    }
  },
  computed: {
    ...mapState('global', {
      'msgCount': state => state.taskMessageCount,
      history: ({ history }) => history.concat([]).reverse().filter(i => i && i.id),
      favorite: ({ favorite }) => favorite.concat([]).reverse(),
      openedMenuLists: state => state.openedMenuLists
    }),
    ...mapState('customize', ['switchVoices', 'forcePasswordChange']),
    /* userName() { // 存在时机问题
      return $store.state.global.userInfo.ename || ''
    } */
  },
  watch: {
    /* openedMenuLists: {
      handler(val) {
        // console.log(val)
        if (val.length) {
          let hasOverview = val.some(i => i.routeFullPath == '/CUSTOMIZED/OVERVIEW/41460840')
          if (!hasOverview) {
            this.updataOpenedMenuLists([
              {
                isActive: true,
                keepAliveModuleName: "C.OVERVIEW.41460840",
                label: '概览',
                routeFullPath: "/CUSTOMIZED/OVERVIEW/41460840",
                routePrefix: "/CUSTOMIZED",
                tableName: "OVERVIEW",
              },
              ...this.openedMenuLists
            ])
          }
        } else {
          R3.store.commit("global/tabOpen", {
            type: "C",
            label: '概览',
            url: '/CUSTOMIZED/OVERVIEW/41460840',
            customizedModuleName: 'OVERVIEW',
            customizedModuleId: '41460840',
          });
        }
        // 导航栏中，去除默认Tab的关闭icon
        setTimeout(() => {
          let span_html = $('.openedMenuLists .ark-tabs-tab');
          if (span_html.length && span_html[0].title == '概览') {
            let close_html = $(span_html[0]).children('i.iconios-close');
            close_html.css({ display: 'none' });
            span_html[0].innerHTML = `<i class="iconfont icon icon-weibiaoti-4" style="line-height: 30px;font-size: 19px;"></i>`;
            $('.ark-tabs-nav').find('.ark-tabs-tab[title=概览]').css('width', '51px');
          }
        }, 100);
      },
    }, */
    msgCount: {
      handler(n, o) {
        // console.log('msgCount::', n, o)
        const self = this
        if (this.switchVoices && (n > o || o == undefined)) {
          // _.debounce(() => {
            const iff = $('#iffff')
            iff.attr('src', '/static/mp3/1702.mp3')
          // }, 1000)
        }
      },
      immediate: true
    },
  },
  async created () {
    const lang = localStorage.getItem("locale") || 'zh'
    if (!window['Ark/locale'] || !window['Ark/locale'].default) {
      await $i18n.lang(lang, 1)
    }
  },
  mounted () {
    setTimeout(async () => {
      /* const conf = JSON.parse(localStorage.getItem('userInfo'))
      if (!conf) return
      const { ename, id } = conf
      this.userName = ename || conf["$USER_ENAME$"]
      // 查性别
      await $utils.getObject("CP_C_HRUSERS", id || conf["$USER_ID$"]).then(data => {
        const arr = data.addcolums.find(it => it.parentname == "(CP_C_HRUSERS.ID+300)").childs;
        const item = arr.find(i => i.colname == 'SEX')
        this.gender = item.valuedata
      }) */
      this.$nextTick(() => {
        // 隐藏框架菜单图标
        if ($('.NaVertical-box .icon-setting .history')[0]) {
          // $('.NaVertical-box .icon-setting .history')[0].style.display = 'none'
          // $('.NaVertical-box .icon-setting .favorite')[0].style.display = 'none'
          $('.NaVertical-box .iconmd-person')[0].parentNode.style.display = 'none'
        }
      })
    }, 200);
    /* const iv = document.getElementById('ivvvv')
    const iff = document.getElementById('iffff')
    this.iff = iff
    iff.onload = function(params) {
      console.log('---------=======');
      // iv.src = '/static/mp3/mm1.mp3'
      // iv.oncanplay = function() {
      //   iv.play()
      // }
    } */

    // // 设置变量
    // document.body.style.setProperty('--baseColor', '#7F583F');
    // // 读取变量
    // let getVal = document.body.style.getPropertyValue('--baseColor').trim();
    // console.log(getVal);
    // 模拟点击，展示搜索框
    document.getElementsByClassName("buttonIcon")[0].click();
    this.$nextTick(() => {

      if (localStorage.getItem("locale") == "en") {
        setTimeout(() => {
          let dom = document.getElementsByClassName("ark-input-default")
          dom[0].placeholder = "please enter the menu"
          return
          const renderFor = [
            {
              key: 'modifyPwd', // 修改密码
              en: `<i class="iconfont iconmd-key explanatory"></i> Change password`
            },
            {
              key: 'panel-item-explanatory', // 折叠查询条件
              en: `<i class="iconfont iconmd-apps explanatory"></i> Collapse search conditions <span tabindex="0" class="switch ark-switch ark-switch-checked ark-switch-default"><input type="hidden" value="true"> <span class="ark-switch-inner"> <!----></span></span>`
            },
            {
              key: 'panel-item-queryDefaultRows', // 查询条件默认显示行数
              en: `<i class="iconfont iconmd-list explanatory"></i>
                Rows of Conditions
                <div class="set-panel-number ark-input-number ark-input-number-default"><div class="ark-input-number-handler-wrap"><a class="ark-input-number-handler ark-input-number-handler-up"><span class="ark-input-number-handler-up-inner ark-icon iconios-arrow-up"></span></a> <a class="ark-input-number-handler ark-input-number-handler-down"><span class="ark-input-number-handler-down-inner ark-icon iconios-arrow-down"></span></a></div> <div class="ark-input-number-input-wrap"><input autocomplete="off" spellcheck="false" placeholder="" class="ark-input-number-input"></div></div>`
            },
            {
              key: 'panel-item-exit', // 退出
              en: `<i class="iconfont iconmd-exit explanatory"></i>Exit`
            },
          ]
          try {
          $('.set-panel .panel-item').each((index, it) => {
            const _it = $(it)
            const cname = _it[0].className
            const inner = renderFor.find(i => cname.includes(i.key))?.en
            if (inner) {
              _it[0].innerHTML = inner
            }
          })

          let xiaoXiDome = document.getElementsByClassName("panel-title")[0].getElementsByClassName("left")
          xiaoXiDome[0].innerText = "Messages"

          let Ignore = document.getElementsByClassName("panel-title")[0].getElementsByClassName("right")
          Ignore[0].innerText = "Ignore"

          let xiaoXiDome2 = document.getElementsByClassName("no-message")[0].getElementsByTagName("span")
          xiaoXiDome2[0].innerText = "No unread messages"

          let tasks = document.getElementsByClassName("panel-bottom")[0].getElementsByClassName("right")
          tasks[0].innerText = "All tasks"
          } catch (e) {
            console.warn(e)
          }

        }, 700)

      }
    });
    let now = new Date();
    let hour = now.getHours();
    let ZH = localStorage.getItem("locale") == "zh"
    this.welcome = ZH ? this.welcome : 'Welcome to R3-OMS !'
    if (hour >= 0 && hour < 8) this.timeTips = '早上好';
    else if (hour >= 8 && hour < 11) ZH ? this.timeTips = '上午好' : this.timeTips = 'Good morning';
    else if (hour >= 11 && hour < 13) ZH ? this.timeTips = '中午好' : this.timeTips = 'Good noon';
    else if (hour >= 13 && hour < 18) ZH ? this.timeTips = '下午好' : this.timeTips = 'Good afternoon';
    else if (hour >= 18 && hour < 24) ZH ? this.timeTips = '晚上好' : this.timeTips = 'Good evening';
    // this.initScreenFull()
    this.navFold()
  },
  /* beforeDestroy () {
    this.destroyScreenFull()
  }, */
  methods: {
    ...mapMutations('global', ['updataOpenedMenuLists']),
    ...mapActions('global', ['signout']),
    showMenu(type) {
      if (type == 1) {
        this.showFavoriteMenu = !this.showFavoriteMenu
        this.showHistoryMenu = false
      } else if (type == 0) {
        this.showFavoriteMenu = false
        this.showHistoryMenu = !this.showHistoryMenu
      } else {
        this.showFavoriteMenu = false
        this.showHistoryMenu = false
      }
    },
    handlerOpenTasks() {
      this.$parent.handlerOpenTasks()
      this.showMenu()
    },
    toggleSetting() {
      this.$parent.show = !this.$parent.show
      this.showMenu()
    },
    /* screenfullFn () {
      console.log("screenfull", screenfull)
      if (!screenfull.enabled) {
        this.$message.warning("您的浏览器暂时不支持全屏")
        return false
      }
      screenfull.toggle()
      this.showMenu()
    },
    initScreenFull () {
      if (screenfull.enabled) {
        screenfull.on('change', this.change)
      }
    },
    change () {
      this.isFullscreen = screenfull.isFullscreen
    },
    destroyScreenFull () {
      if (screenfull.enabled) {
        screenfull.off('change', this.change)
      }
    }, */
    navFold() {
      this.$nextTick(() => {
        OMS.cssHandleUtils.navFoldPosition();
        // 监听框架导航折叠Icon
      })
      $('.r3-content-nav .NaVertical-bar .iconfont.iconbj-fold').on('click', () => {
        setTimeout(() => {
          OMS.cssHandleUtils.navFoldPosition();
          OMS.cssHandleUtils.refreshAgTableHeight() // 渲染定制列表页面ag表格
        }, 100)
      })
    },
    routeTo(menu) {
      utils.routeTo(menu)
    },
    closePwdDialog() {
      // 用户账号第一次登录/重置密码首次登录必须修改密码，点击取消则退出登录
      if (this.forcePasswordChange) {
        this.signout()
      }
    },
    attachEvent(eventName, callback) {
      window.addEventListener(eventName, callback)
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener(eventName, callback)
      })
    },
  }
};
</script>

<style lang="less">
@import 'omsTheme/index.less';
.async-task-icon{
  svg{
    color: var(--t-text) !important
    // color: #fff!important;
  }
}
.tag.favorite:before {
  content: "";
}
// 头部导航有关系的所有样式
// 收拉左侧菜单
.NaVertical-icons {
  position: absolute;
  .iconbj-unfold,
  .iconbj-fold {
    &::before {
      content: "";
    }
    position: fixed;
    top: 40%;
    left: 55px;
    transform: translateY(-50%);
    display: inline-block;
    width: 12px;
    height: 40px;
    background: url("~assetsImg/icon_unfold2.png") right no-repeat;
    background-size: 100% auto;
    z-index: 99;
  }
  .iconbj-fold {
    left: 170px;
    background: url("~assetsImg/icon_fold2.png") right no-repeat;
    background-size: 100% auto;
  }
}

.NaVertical {
  height: 48px !important;
  background-color: var(--b1-color) !important;
  .icon-setting {
    display: flex;
    flex-direction: row-reverse; // 没有jflow图标时
    .iconlogo-jflow {
      font-size: 21px !important;
    }
    .tag {
      padding: 0;
      &:hover {
        background: var(--b1-color_x1);
      }
      &:first-child {
        order: 2;
      }
    }
  }
  .tag {
    order: 1;
    line-height: 48px;
    // width: 50px;
    width: auto;
    min-width: 56px;
    padding: 0 15px;
    .buttonIcon {
      vertical-align: initial !important;
    }
    &.message-tag {
      padding: 0;
    }
    &:hover {
      background: var(--b1-color_x1);
    }
    .iconios-arrow-down {
      margin-left: 5px;
      &:before {
        font-size: 13px;
        line-height: 31px;
      }
    }
    .person {
      width: 28px;
      vertical-align: middle;
      // margin-left: -10px;
      &.famale {
        border: 1px solid #fff;
        border-radius: 50%;
        padding: 2px;
        background-color: #ececec;
      }
    }
    .ark-badge + span,
    i ~ span {
      margin-left: -5px;
      display: none;
    }
    .ark-badge {
      width: 40px;
      height: 48px !important;
      margin-top: 1px;
    }
  }
  .tag-title {
    font-size: 13px;
    color: var(--t-text);
    font-family: inherit;
    vertical-align: middle;
  }
  .tag-search {
    margin-right: 8px;
    width: 203px;
    &, * {
      font-size: 0;
    }
    .ark-input-wrapper {
      display: flex;
      align-items: center;
    }
  }
  .NaVertical-box {
    width: 100%;
    justify-content: flex-end;
    .timeTips {
      flex: 1;
      line-height: 52px;
      font-size: 13px;
      color: var(--t-text);
      padding-left: @base-mr;
      i.icon-fullscreen-expand,
      i.icon-fullscreen-shrink {
        float: right;
        margin-right: 10px;
        font-size: 24px;
        color: #3870c1;
      }
    }
    .music + div.tag {
      display: none;
    }
  }
  .nav-search i {
    margin-top: 0;
  }
  .nav-search input {
    // #bundle > .defalutInput !important;
    height: 26px !important;
    line-height: 26px !important;
    color: var(--t-text) !important;
    border: 1px solid var(--t-text) !important;
    border-radius: 2px !important;
    background: transparent;
    font-size: 13px;
    margin-top: 0;
    &::-webkit-input-placeholder {
      color: var(--t-text) !important;
      opacity: 0.7;
      font-size: 13px;
    }
    &:hover {
      padding: 0 8px !important;
      font-size: 13px;
    }
  }
}
// 历史
.history,
.favorite {
  .ark-select-dropdown {
    ul {
      li {
        text-align: left;
      }
    }
  }
  .ark-select-dropdown {
    margin-top: 10px;
  }
  .ark-select-dropdown::before {
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("~assetsImg/arrowTop.png") top no-repeat;
  }
}
.favorite {
  .ark-select-dropdown::before {
    #bundle > .absolute(@top:-13px,@left:50%,@X:-50%);
  }
}
.history {
  .ark-select-dropdown::before {
    #bundle > .absolute(@top:-13px,@left:50%,@X:-50%);
  }
}
// 消息
.message-panel {
  .panel-main {
    width: 420px;
    // border-left: 70px solid rgba(0,0,0,.5);
    .panel-title {
      padding: 0 @base-mr !important;
      height: 48px !important;
      line-height: 47px !important;
      border-bottom: 1px solid #f2f2f2 !important;
      &::before {
        display: inline-block;
        content: "";
        width: 4px;
        height: 16px;
        border-radius: 4px;
        background: @base-color;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: @base-mr;
        color: #292f43;
      }
      .right {
        height: 48px !important;
        line-height: 48px !important;
        color: @base-color !important;
      }
    }
    .no-message {
      padding-top: 180px;
      background: url("~assetsImg/message.png") top no-repeat #ffffff;
      background-size: 160px 160px;
    }
  }
}
// 管理员
.set-panel {
  .panel-main {
    .panel-item {
      border-bottom: none;
      .explanatory {
        margin-right: 5px;
        color: #8d91a1;
      }
      p {
        color: #292f43;
      }
      &:first-child {
        p {
          color: #8d91a1;
          i.iconmd-contact::before {
            content: "";
          }
        }
      }
    }
    // 隐藏框架修改密码
    .panel-item-changePwd {
      display: none;
    }
    // 个人中心面板菜单icon
    .wrap .panel-item {
      &:first-child p {
        color: #292f43;
        i.iconmd-color-palette::before {
          content: "\ec9f";
        }
      }
      .icon-skin,
      .iconmd-color-palette, .iconios-expand {
        color: #8d91a1;
        margin-right: 3px;
      }
      &.oms-theme {
        .tag-title {
          color: #292f43;
        }
        .iconios-arrow-down {
          display: none;
        }
      }
    }
  }
}
.nav-menu {
  position: absolute;
  top: 50px;
  z-index: 9999;
  max-width: 140px;
  background-color: #fff;
  border-bottom: 1px solid #d1dbe5;
  color: #333;
  font-size: 14px;
  overflow: auto;
  width: fit-content;
  box-shadow: 0 9px 9px 0 rgb(186 185 185 / 35%);
  .menu-ul {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    // margin-bottom: 20px;
    text-align: left;
    border: 1px solid #f0f8ff;
    border-top: none;
    max-height: 200px;
    overflow-y: auto;
    padding-top: 7px;
    .menu-li {
      float: left;
      cursor: pointer;
      min-width: 140px;
      flex: 0 0 140px;
      background-color: #fff;
      padding: 0 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      white-space: nowrap;
      height: 32px;
      line-height: 32px;
      color: #515a6e;
      font-size: 12px;
      &:hover {
        color: #fff;
        background-color: #0068b7;
      }
    }
  }
}
</style>

<style lang="less" scoped>
.NaVertical-box {
  .iconios-star-outline:before {
    // 收藏
    content: "\ef2d";
  }
  .iconmd-notifications-outline:before {
    // 消息
    content: "\efed";
    font-size: 17px;
  }
  .iconios-help-circle-outline:before {
    // 帮助
    content: "\e670";
  }
}
</style>
